import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Box, Typography } from "@mui/material";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    description: string;
};

export default function DeleteConfirmDialog({ open, onClose, onConfirm, title, description }: Props) {
  return (
    <Dialog 
        open={open} 
        onClose={onClose}
        PaperProps={{
            sx: { borderRadius: 4, p: 1, maxWidth: 400 }
        }}
    >
        <Box sx={{ textAlign: 'center', pt: 3, px: 2 }}>
            <Box sx={{
                color: 'error.main', 
                width: 64, 
                height: 64, 
                borderRadius: '50%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                mx: 'auto',
                mb: 2,
                bgcolor: 'rgba(239, 68, 68, 0.1)' // hardcoded red-50 equivalent
            }}>
                <DeleteOutlineIcon sx={{ fontSize: 32 }} />
            </Box>
            <Typography variant="h6" fontWeight={700} gutterBottom>
                {title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                {description}
            </Typography>
        </Box>
        <DialogActions sx={{ px: 3, pb: 3, justifyContent: 'center', gap: 1 }}>
            <Button onClick={onClose} variant="outlined" color="inherit" fullWidth sx={{ borderRadius: 2 }}>
                Cancel
            </Button>
            <Button onClick={onConfirm} variant="contained" color="error" fullWidth autoFocus sx={{ borderRadius: 2 }}>
                Delete
            </Button>
        </DialogActions>
    </Dialog>
  );
}
